import { render } from "./TabelaComponent.vue?vue&type=template&id=9cbc02ce&scoped=true"
import script from "./TabelaComponent.vue?vue&type=script&lang=js"
export * from "./TabelaComponent.vue?vue&type=script&lang=js"

import "./TabelaComponent.vue?vue&type=style&index=0&id=9cbc02ce&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cbc02ce"]])

export default __exports__